import apiClient  from './Client';

interface Product {
    productID: number,
    productName: string,
    description: string,
    basePrice: number,
    productTypeId: number,
    imageUrl: string,
    width: number,
    height: number
}

class ProductService {
        // Method to get product list by productTypeId
        getProductList = async (productTypeId: number): Promise<Product[]> => {
            try {
                const response = await apiClient.get(`/Product/list/${productTypeId}`);
                console.log("Product list fetched:", response.data);
                return response.data; 
            } catch (error) {
                console.error("Failed to fetch product list", error);
                throw error;  
            }
        };

        async GetProductTypes() { 
            console.log('GetProductTypes');
            try {
                const response = await apiClient.get("/Product/GetProductTypeList"); 
                console.log(response);
                return response.data;          
            } catch (err:any) {
                         
            }
        };
}
export default new ProductService()